// Modules
import React from 'react'
import { useHistory } from 'react-router-dom'
import { ErrorResponse } from 'apollo-link-error'

// Application
import { useActiveCIPOrphanHook, useAnalytics, useAccountMDMHook } from 'hooks'
import { Contact, ContactType } from 'typings'
import { useApp } from 'context'
import { Analytics, OutputErrorCode, OutputErrorMsg, ROUTES_PATH } from 'constants/index'
import { ConfirmContact } from 'components/Presenters/ConfirmContact'

// Components
import { Header, TemplateContainer } from 'components'
import { SelectContact, SelectContactInitial } from 'components/Presenters/SelectContact'

export const MDMCIPSelectContact: React.VFC = () => {
    const accountMDM = useActiveCIPOrphanHook()
    const history = useHistory()
    const { openToast } = useApp()
    const { setPatientLoginMdmAccount } = useAccountMDMHook()

    const shouldRedirect = !accountMDM?.cpf || !accountMDM?.biologicalSex || !accountMDM?.password

    // evento funil
    useAnalytics(Analytics.ActivateAccountCipOrphan.MdmAccountContact, !shouldRedirect)

    if (!accountMDM.hasMounted) {
        return null
    }

    if (shouldRedirect) {
        history.push(ROUTES_PATH.SIGN_UP_REGISTER_ACTIVATION_CPF)
        return null
    }

    const handleSubmit = async (values: SelectContactInitial) => {
        try {
            await accountMDM.setSubmitting(true)
            const contactData: Contact = {
                id: values.contact?.id,
                value: values.contact?.value,
                contactType: values.contact?.contactType,
            }
            const contactType = values.contact?.contactType === 'EMAIL' ? ContactType.EMAIL : ContactType.MOBILE

            await accountMDM.setContact(contactData)
            const patient = {
                password: accountMDM.password,
                cpf: accountMDM.cpf,
                contactId: contactData.id,
                biologicalSex: accountMDM.biologicalSex,
                cep: accountMDM.postalCode,
                destinationToken: contactType,
            }

            const {
                createLoginResponse: { cipIntegrationStatus },
            } = await accountMDM.createLogin(patient)
            await setPatientLoginMdmAccount(cipIntegrationStatus)
            await accountMDM.setSubmitting(false)

            history.push(ROUTES_PATH.SIGN_UP_MDM_CIP_VALIDATE_TOKEN)
        } catch (err) {
            const e: ErrorResponse = err

            if (e.graphQLErrors) {
                const error = e.graphQLErrors[0].extensions?.body.error

                if (error === OutputErrorCode.PHONEALREADYINUSE || error === OutputErrorCode.EMAILALREADYINUSE) {
                    openToast(OutputErrorMsg.PHONEALREADYINUSE)
                } else {
                    openToast(OutputErrorMsg.GENERICERROR)
                }
                return
            }
        }
    }

    const contacts: Array<Contact> = []
    contacts.push(...(accountMDM.phoneContacts || []))
    contacts.push(...(accountMDM.emailContacts || []))

    if (contacts.length > 0) {
        return (
            <TemplateContainer>
                <Header
                    subtitle="Escolha um desses contatos para receber o código de validação da sua conta Nav Dasa:"
                    title="Confirme que é você"
                />
                <SelectContact
                    contacts={contacts}
                    handleSubmit={handleSubmit}
                    initialValues={{ contact: contacts[0] }}
                    isSubmitting={accountMDM.isSubmitting}
                />
            </TemplateContainer>
        )
    }

    return <ConfirmContact nextUrl="/login" />
}
